module.exports = __webpack_public_path__ + "3e60403316627760e04872f4ade8b0ad.pdf";